import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-tai-chi-yoga': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga&exp=web_tai_chi_yoga_male_scratch_card~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_tai_chi_yoga_male_scratch_card'),
			},
		},
		'activity-male-tai-chi-yoga-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_tai_chi_yoga_male_scratch_card~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_tai_chi_yoga_male_pr_scratch_card'),
			},
		},
	},
]

export default config
